import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function isMessageOptionDirty(state) {
    var savedOptions = state.userOptions;
    var emptyDeletedItemsOnLogOut = getFallbackValueIfNull(state.optionState.emptyDeletedItemsOnLogOut, savedOptions.EmptyDeletedItemsOnLogoff);
    return emptyDeletedItemsOnLogOut !== savedOptions.EmptyDeletedItemsOnLogoff;
});
//# sourceMappingURL=isMessageOptionDirty.js.map